import debounce from "debounce";
export type DebounceParams = number | [number, boolean];
export const createDebounce = <F extends Function>(
  fn: F,
  params?: DebounceParams
) =>
  params
    ? typeof params === "number"
      ? debounce(fn, params)
      : debounce(fn, params[0], params[1])
    : fn;

const callbacks = new WeakMap();
export const useDebounce = <T, F extends (...args: any[]) => T>(
  fn: F,
  params?: DebounceParams
): ReturnType<typeof debounce<F>> => {
  if (!callbacks.has(fn)) {
    const [timeout, immediate] =
      params === undefined
        ? [200, false]
        : typeof params === "number"
        ? [params, false]
        : params;
    callbacks.set(fn, debounce(fn, timeout, immediate));
  }
  return callbacks.get(fn);
};
